module.exports = __webpack_public_path__ + "static/img/cz01.b646c115.png";